import './HomePage.scss'

export default function Current() {
   return (
      <div className="d-flex flex-column justify-content-start align-items-center current-comp-container">
        <div className="current-btn__container">
          {/* <h4 className='current-head'>Now Available</h4> */}
          <a className="box-btn current-btn btn-lg current2-btn" href="/basketballleague" role="button">Mini Madness</a>
          <hr />
          <a className="box-btn current-btn btn-lg current2-btn" href="/basketballleague" role="button">No So Mini</a>
          <hr />
          <a className="box-btn current-btn btn-lg current2-btn" href="/606atLotus" role="button">Afterschool Club</a>
        </div>
      </div>
    )
}